module.exports = __webpack_public_path__ + "media/8.31ee50c5.wav";